import { selectWarehouses } from 'containers/Warehouses/warehousesSlice'
import Warehouse from 'containers/Warehouses/WarehouseComponent'
import useWarehousesLoading from 'hooks/useWarehousesLoading'
import { ReactComponent as Mag } from 'assets/magLogo.svg'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Loading from 'components/Loading'
import { useReduxSelector } from 'store'
import './style.scss'

const type = process.env.REACT_APP_TYPE

const Warehouses = () => {
  const isLoading = useWarehousesLoading()
  const warehouses = useReduxSelector(selectWarehouses)

  const { push, location: { pathname } } = useHistory()
  const { t } = useTranslation()

  return (
    <div className='desktopWarehouses'>
      {type === 'mm'
        ? <div className='title'>
          <div>{t('warehouse.myRentals')}</div>
          <div>{t('warehouse.selectAnObjectToManage')}</div>
        </div>
        : <div className='title'>
          <div>{t('warehouse.myWarehouses')}</div>
          <div>{t('warehouse.selectAWarehouseToManage')}</div>
        </div>}

      {warehouses?.length > 0
        ? <div className='desktopWarehouses__grid'>
          {warehouses?.map((warehouse) =>
            <div
              key={warehouse.objectId}
              className='item'
              onClick={() => push(`${pathname}/${warehouse.objectId}`)}>
              <div className='item__img'>
                <Warehouse
                  {...warehouse}
                />
              </div>
              <div className='item__desc'>
                <h2>{warehouse.typeName + ' (nr.' + warehouse.number + ')'}</h2>
                <span>{warehouse.placeAddress}</span>
                {warehouse.isShared && <span className='shared'><i className='icon icon--share'></i>Udostępniony od: {warehouse.acronym}</span>}
              </div>
            </div>)}
          <div
            className='item --commercial'
            onClick={() => {
              push((type === 'mm' || type === 'box') ? '/categories' : '/home')
            }}>
            <div className='commercial__title --secFont'>{t('warehouse.rentANewOne')}</div>
            {type === 'mm'
              ? <Mag />
              : <div className='commercial__title--secondary --secFont'>
                {t((type === 'rze01' || type === 'chr01' || type === 'box' || type === 'demo') ? `basic.box.${type}` : 'basic.warehouse')}
              </div>}
          </div>
        </div>
        : isLoading
          ? <Loading middleOfPage />
          : <div className='desktopWarehouses__message'>
            <div className='desktopWarehouses__message__header'>{t('warehouse.noStorageYet')}</div>
            <ArrowBtn
              enlarged
              text={t('warehouse.rentANewOne')}
              action={() => {
                push((type === 'mm' || type === 'box') ? '/categories' : '/home')
              }}
            />
          </div>}
    </div>
  )
}

export default Warehouses